(function () {
    'use strict';
    function main() {
        var phoneSearchController = {
            init: function () {
                wo$('[data-enable-when-ready]').removeAttr('disabled');
                phoneSearchController.registerNotifications();
                phoneSearchController.initHistoryTracker();
                phoneSearchController.trackPage(false);
                WhistleOut.getAds('MobilePhones');

                wo$('a[data-action="scroll-top"]')
                    .off('click')
                    .click(function () {
                        WhistleOut.scrollTo(0);
                        return false;
                    });

                wo$('.wrapper-3').on('affixed.bs.affix', function () {
                    wo$('.wrapper-3 div').removeClass('hidden');
                });

                wo$('[data-clear-filters]')
                    .off('click')
                    .click(function (e) {
                        e.preventDefault();
                        var criteria = WhistleOut.readLookupData(wo$('[data-search-criteria]'), true);
                        criteria.brands = [];
                        criteria.models = [];
                        criteria.operatingSystems = [];
                        criteria.suppliers = [];
                        criteria.networks = [];
                        criteria.minScreen = null;
                        criteria.maxScreen = null;
                        criteria.camera = null;
                        criteria.minSpend = null;
                        criteria.maxSpend = null;
                        criteria.maxUpfront = null;
                        criteria.priceTypes = [];
                        criteria.released = null;
                        criteria.planType = null;
                        criteria.search = null;
                        criteria.singlePhonePerBrand = null;
                        criteria.showEditorsPicksOnly = null;
                        criteria.show5G = null;
                        criteria.showESim = null;
                        criteria.showTelstraBlueTickOnly = null;
                        criteria.optusRegionalPickOnly = null;
                        criteria.sortExpression = null;
                        criteria.sortAscending = true;
                        criteria.minData = null;
                        WhistleOut.notifications.fire('FilterChanged', { type: 'Widen', criteria: criteria });
                    });
            },

            registerNotifications: function () {
                WhistleOut.notifications.add(function (notification, data) {
                    if (notification === 'FilterChanged') {
                        wo$('[data-enable-when-ready]').attr('disabled', 'disabled');
                        phoneSearchController.updateFilters(data.criteria, false);
                    } else if (notification === 'SearchResultsRendered') {
                        phoneSearchController.setFilterValues();
                        phoneSearchController.trackPage(data.isAjax);
                        WhistleOut.getAds('MobilePhones');
                        wo$(window).resize();
                    }
                });
            },

            setFilterValues: function () {
                var queryData = WhistleOut.readLookupData(wo$('[data-search-criteria]'), true);
                wo$('[data-sub-heading]').text(queryData.subHeading);
                wo$('[data-sub-heading]').siblings().addClass('hidden');
                if (queryData.subHeadingElementsCount === 0) {
                    wo$('[data-sub-heading]').siblings('[data-subheading-elements=0]').removeClass('hidden');
                } else {
                    if (queryData.hasHeadingElement && queryData.subHeadingElementsCount > 1) {
                        wo$('[data-sub-heading]').siblings('[data-subheading-elements=1]').removeClass('hidden');
                    }
                    wo$('[data-sub-heading]').siblings('[data-subheading-elements=n]').removeClass('hidden');
                }

                wo$('meta[name=description]').attr('content', queryData.meta);
                document.title = queryData.title;
            },

            updateFilters: function (criteria, fullReload) {
                WhistleOut.startProgress('#search-results-partial', 0.1, 50);
                var queryString = '?' + WhistleOut.MobilePhones.generatePhonesQueryString(criteria);
                if (fullReload) {
                    location.href = criteria.searchUrl + queryString;
                    return;
                }
                var resultsUrl = criteria.searchResultsAjaxUrl;
                wo$('[data-enable-when-ready]').attr('disabled', 'disabled');
                wo$.ajax({
                    url: resultsUrl + '?' + WhistleOut.MobilePhones.generatePhonesQueryString(criteria),
                    type: 'GET',
                    success: function (result) {
                        var $results = wo$('#search-results-partial');
                        $results.html(result);
                        phoneSearchController.HistoryWrapper.pushQuery(queryString);
                        criteria = WhistleOut.readLookupData(wo$('[data-search-criteria]'), true);
                        WhistleOut.notifications.fire('SearchResultsRendered', {
                            criteria: criteria,
                            isAjax: !fullReload
                        });
                        wo$('[data-enable-when-ready]').removeAttr('disabled');
                        WhistleOut.endProgress();
                        wo$(window).resize();
                    },
                    error: function () {
                        WhistleOut.endProgress();
                    }
                });
            },

            trackPage: function (isAjax) {
                var criteria = WhistleOut.readLookupData(wo$('[data-search-criteria]'), true);
                var values = [];
                values.push(criteria.minScreen);
                values.push(criteria.maxScreen);
                values.push(criteria.camera);
                values.push(criteria.brands.length > 0 ? criteria.brands.join(',') : null);
                values.push(criteria.operatingSystems.length > 0 ? criteria.operatingSystems.join(',') : null);
                values.push(criteria.networks.length > 0 ? criteria.networks.join(',') : null);
                values.push(criteria.suppliers.length > 0 ? criteria.suppliers.join(',') : null);
                values.push(criteria.maxUpfront);
                values.push(criteria.maxSpend);
                values.push(criteria.released);
                values.push(criteria.priceTypes.length > 0 ? criteria.priceTypes.join(',') : null);
                values.push(null);
                values.push(null);
                values.push(null);
                values.push(/*resultCount*/); //ToDo: result count
                var valuesString = values.join('|');

                WhistleOut.trackPageView(null, valuesString, isAjax);
            },

            initHistoryTracker: function () {
                WhistleOut.initHistoryTracker(phoneSearchController);
            }
        };

        phoneSearchController.init();
    }
    WhistleOut.initModule(import.meta.url, main);
})();
